import {
  createPreviewActions,
  ShareablePreview,
} from "@/core/components/shared/preview-action";
import useTypedTranslation from "@/core/hooks/use-typed-translation";

/**
 * Confirmation de clôture d'un portefeuille (`POST /Wallets/{id}/status?status=CLOSED`,
 * guide §6.3). Pas de frais : ShareablePreview avec récap identifiant.
 */
export function CloseWalletConfirmDialog({
  open,
  onOpenChange,
  walletId,
  walletNumber,
  pending,
  onConfirm,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  walletId: string;
  walletNumber?: string;
  pending: boolean;
  onConfirm: () => void;
}) {
  const { t } = useTypedTranslation();
  const walletRef = walletNumber || walletId;

  if (!open) return null;

  return (
    <ShareablePreview
      data={{
        walletId,
        walletNumber: walletRef,
        nextStatus: "CLOSED",
      }}
      title={t("wallet.wallets.close.title")}
      description={t("wallet.wallets.close.description", {
        walletNumber: walletRef,
      } as never)}
      mode="user"
      defaultOpen
      onOpenChange={(isOpen) => {
        if (!isOpen && !pending) onOpenChange(false);
      }}
      maxHeight="90vh"
      actions={createPreviewActions({
        onConfirm,
        onCancel: () => onOpenChange(false),
        t,
        labels: { confirm: t("wallet.wallets.close.confirm") },
        confirmLoading: pending,
        withIndicatorOnConfirm: true,
      })}
    />
  );
}
